import React, { Fragment, useEffect, useState } from 'react';
import Circle from '../../models/Circle';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';
import ToggleSwitch from '../../components/ToggleSwitch';

const FormPartial = (props) => {
  const { circle, setCircle } = props;
  let circleObj = new Circle(circle);
  const [zones, setZones] = useState([]);
  const [zonesApi] = getApi('zones');

  useEffect(() => {
    fetchApiData(zonesApi, "zones", { fields: 'options' }, setZones);
  }, [])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      let response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      toast.error(error.data?.message || "Something Went Wrong !");
    }
  }

  const validateValue = (field) => {
    if(field === 'prebooking_fee_refundable'){
      circleObj.validate('prebooking_fee');
    }
    circleObj.validate(field);
  }

  const changeValue = (field, value) => {
    if(field === 'pincode'){
      if((value).toString().length > 6){
        return false;
      }
    }
    circleObj[field] = value;
    validateValue(field)
    setCircle(circleObj.toStateJson());
  }

  const onZoneSelect = (selectedList, selectedItem) => {
    circleObj.zone = selectedItem;
    validateValue('zone');
    setCircle(circleObj.toStateJson());
  }

  return <Fragment>
    <div className="row mt-4">
      <div className="col-md-3 my-2">
        <label htmlFor="name" className="form-label mb-1">Name</label>
        <input
          id="name"
          value={circleObj.name}
          onChange={(e) => changeValue('name', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Name'
          aria-describedby="name_help"
        />
        <div id="name_help" className="form-text text-danger mt-0">
          {circleObj.errors.name}
        </div>
      </div>
      <div className="col-md-3 my-2">
        <label htmlFor="sap_code" className="form-label mb-1">SAP Code</label>
        <input
          id="sap_code"
          value={circleObj.sap_code ? circleObj.sap_code.toUpperCase() : ""}
          onChange={(e) => changeValue('sap_code', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Circle Code'
          aria-describedby="sap_code_help"
        />
        <div id="sap_code_help" className="form-text text-danger mt-0">
          {circleObj.errors.sap_code}
        </div>
      </div>
      <div className="col-md-3 my-2">
        <label htmlFor="address" className="form-label mb-1">Address</label>
        <input
          id="address"
          value={circleObj.address}
          onChange={(e) => changeValue('address', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Address'
          aria-describedby="address_help"
        />
        <div id="address_help" className="form-text text-danger mt-0">
          {circleObj.errors.address}
        </div>
      </div>
      <div className="col-md-3 my-2">
        <label htmlFor="zone" className='form-label mb-1'>Select Zone</label>
        <Multiselect
          id="zone"
          options={zones}
          selectedValues={circleObj.zone ? [circleObj.zone] : []}
          onSelect={onZoneSelect}
          placeholder='Select from options'
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          singleSelect={true}
          avoidHighlightFirstOption={true}
        />
        <div id="zone_help" className="form-text text-danger mt-0">
          {circleObj.errors.zone}
        </div>
      </div>
      <div className="col-md-3 my-2">
        <label htmlFor="prebooking_fee_refundable" className="form-label mb-1">Prebooking Fee Refundable</label>
        <ToggleSwitch
          id="prebooking_fee_refundable"
          label_left="False"
          label_right ="True"
          onChange={(e) => changeValue('prebooking_fee_refundable', !circleObj.prebooking_fee_refundable)}
          checked={circleObj.prebooking_fee_refundable}
          className="form-control"
        />
      </div>
      <div className="col-md-3 my-2">
        <label htmlFor="prebooking_fee" className="form-label mb-1">Prebooking Fee</label>
        <input
          id="prebooking_fee"
          value={circleObj.prebooking_fee}
          onChange={(e) => changeValue('prebooking_fee', e.target.value)}
          type="number"
          className="form-control form-control-sm font-size-12"
          placeholder='₹ 0.00/-'
          aria-describedby="prebooking_fee_help"
          disabled={!circleObj.prebooking_fee_refundable}
        />
        <div id="prebooking_fee_help" className="form-text text-danger mt-0">
          {circleObj.errors.prebooking_fee}
        </div>
      </div>
      <div className="col-md-3 my-2">
        <label htmlFor="pincode" className="form-label mb-1">PIN Code</label>
        <input
          id="pincode"
          value={circleObj.pincode}
          onChange={(e) => changeValue('pincode', e.target.value)}
          type="number"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter PIN Code'
          aria-describedby="pincode_help"
        />
        <div id="pincode_help" className="form-text text-danger mt-0">
          {circleObj.errors.pincode}
        </div>
      </div>
    </div>
  </Fragment>
}

export default FormPartial;
